<template>
  <Section
    @back="$emit('back')"
    title="PTA対象設定"
    margin
    tip-message="PTA対象設定に戻る"
  >
    <template>
      <v-subheader>対象年代</v-subheader>
      <v-layout pl-4>
        <v-flex xs9>
          {{ targetAgesStr }}
        </v-flex>
      </v-layout>
    </template>
    <CampaignModalPageConfirmArea :menuSetting="menuSetting" />
    <template v-if="menuSetting.memo !== ''">
      <v-subheader>備考</v-subheader>
      <v-layout pl-4>
        <v-flex xs9>
          {{ menuSetting.memo }}
        </v-flex>
      </v-layout>
    </template>
  </Section>
</template>

<script>
import Section from './CampaignModalPageConfirmSection'
import CampaignModalPageConfirmArea from './CampaignModalPageConfirmArea'

export default {
  name: 'CampaignModalPageConfirmPTATarget',
  components: {
    Section,
    CampaignModalPageConfirmArea,
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    menuSetting() {
      return this.form.campaign.menuSetting.orderDescription
    },
    targetAgesStr() {
      const ages = [
        { name: '0 - 4 歳', code: 1 },
        { name: '5 - 9 歳', code: 2 },
        { name: '10 - 14 歳', code: 3 },
        { name: '15 - 19 歳', code: 4 },
      ]
      return this.menuSetting.targetAges
        .map(targetAgeCode => ages.find(age => age.code === targetAgeCode).name)
        .join(', ')
    },
  },
}
</script>
